import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import Pricing from './components/Pricing';
import GetStarted from './components/GetStarted';
import AboutPage from './components/company/AboutPage';
import FeaturesPage from './components/product/FeaturesPage';
import ContactPage from './components/company/ContactPage';
import UpdatesPage from './components/product/UpdatePage';
import CommunityPage from './components/resources/CommunityPage';
import FeedbackPage from './components/resources/FeedbackPage';
import AccountPage from './components/AccountPage';
import PoliciesPage from './components/PoliciesPage';
import TeamInfoPage from './components/TeamInfoPage';
import './index.css';
import ConsentBanner from './analytics/ConsentBanner';
import SeoManager from './seo/SeoManager';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <SeoManager />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/LoginPage" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/policies" element={<PoliciesPage />} />
        <Route path="/TeamInfo" element={<TeamInfoPage />} />
      </Routes>
      <ConsentBanner />
    </Router>
  </React.StrictMode>
);
